"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingOverlay = void 0;
var _Loader = require("../Loader");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const LoadingOverlay = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.Loader, {})
});
exports.LoadingOverlay = LoadingOverlay;
